import React from 'react';
import '../../terms-conditions-policies.scss';

const TermsConditions = () => (
  <section className="terms-conditions-cont">
    <article className="tcp-section-header">
      <h1>Terms of Service</h1>
      <p>
        Please read these Terms and Conditions carefully. By accessing our website, you are
        agreeing to be bound by these terms of service, all
        applicable laws and regulations, and agree that you are responsible for compliance with any
        applicable local laws.
      </p>
    </article>
    <article className="tcp-section-body">
      <p>
        Please note that the company provides services in
        India and in
        compliance with Indian law. Except as specified in the terms of use or as agreed with the
        company in writing, in
        case the user is a citizen or resident of the European union, the state of California or any
        other jurisdiction
        which prescribes or regulates the use of personal information or which imposes additional
        requirements for the use
        of personally identifiable information in addition to Indian law or is inconsistent with
        Indian law, the user is
        required to determine the suitability of the use of the services. The company reserves the
        right to deny usage to
        such residents or citizens based on its evaluation and the user’s acceptance of these Terms
        of
        Service will not
        bind the company.
      </p>

      <ol className="tcp-main-ol">
        <li>
          <span className="tcp-section-item-header">Introduction</span>
          <ol>
            <li>
              These Terms and Conditions (“
              <b>Terms of Use</b>
              ”) govern a user’s use of www.leegality.com
              (the
              “
              <b>Website</b>
              ”) owned by Grey
              Swift Private Limited (the “
              <b>Company</b>
              ”) and any services provided by the Company
              (“
              <b>Services</b>
              ”).
              These Terms of Use
              include and incorporate the references, policies and guidelines. The Company reserves
              the
              right
              to change or revise
              the Terms of Use at any time by posting any changes or revised Terms of Use on this
              website.
              The
              changed or revised
              Terms of Use shall be effective from the moment it is posted on the Website. A user’s
              use
              of
              the
              website following
              the posting any such changes or of a revised Terms of Use shall constitute the user’s
              acceptance
              of any such changes
              or revisions. The Company encourages a user to review these Terms of Use whenever a
              user
              visits
              the Website or uses
              the Services to make sure that the user understands the terms and conditions governing
              this
              website. If the user
              does not agree to these Terms of Use (including any referenced policies or
              guidelines),
              the
              user
              must immediately
              terminate the user’s use of the Website.
            </li>
            <li>
              For the purpose of these Terms of Use, wherever the context so requires “
              <b>You</b>
              ” or
              “
              <b>User</b>
              ”
              shall
              mean any natural or
              legal person who has agreed to use this Website by providing registration data while
              registering
              on the Website as a
              registered user. A user may surf this Website without registering on the Website but
              they
              might
              not have full access
              of the Website.
            </li>
            <li>
              In case of any conflict between these Terms of Use and any specific written agreement
              entered
              into between the
              Company and a User, the terms of such written agreement shall prevail.
            </li>
            <li>
              Any new product or services provided by the Company, or any new features or tools
              which
              are
              added to the Website or
              for the Services shall, unless specifically stated otherwise, be subject to these
              Terms
              of
              Use.
            </li>
          </ol>
        </li>
        <li>
          <span className="tcp-section-item-header">Membership Eligibility</span>
          <ol>
            <li>
              The User affirms that the User is either more than 18 years of age, or an emancipated
              minor,
              or
              possess legal
              parental or guardian consent, and are fully able and competent to enter into the
              terms,
              conditions, obligations,
              affirmations, representations, and warranties set forth in these Terms of Use, and to
              abide by
              and comply with these
              Terms of Use.
            </li>
            <li>
              The User agrees that the User has provided true, accurate, current and complete
              information to
              the Company in
              connection with any use or access of the Service.
            </li>
            <li>
              Users must be identified by a unique email address or phone number and two or more
              natural
              persons may not use the
              Services as the same User.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Account & Registration Obligations</span>
          <ol>
            <li>
              If the User uses this Website, the User shall be responsible for maintaining the
              confidentiality
              of the User’s
              Account, including but not limited to password and the User shall be responsible for
              all
              activities that occur from
              the User’s account. The User agrees that if the User provides any information that is
              untrue,
              inaccurate, not
              current or incomplete or Website has reasonable grounds to suspect that such
              information
              is
              untrue, inaccurate, not
              current or incomplete, or not in accordance with these Terms of Use, Website shall
              have
              the
              right to indefinitely
              suspend or terminate or block access of the User’s membership on the Website and
              refuse
              to
              provide the User with
              access to the Website and the Services.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Privacy</span>
          <ol>
            <li>
              The User’s privacy is very important to the Company, which is why we have created a
              separate
              Privacy Policy in order
              to explain in detail how we collect, manage, process, secure and store the User’s
              private
              information which is
              available at www.leegality.com/privacy-policy.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Third Party Information on the Website</span>
          <ol>
            <li>
              The User acknowledges and agrees that the Company provides access to such links,
              website,
              tools
              and services “as is”
              and “as available” without any warranties, representations or conditions of any kind
              and
              without
              any endorsement and
              the Company does not warrant and will not have any liability or responsibility for any
              third-party materials or
              websites, or for any materials, products, or services of third-parties such as SMS
              service
              providers, delivery and
              courier partners, certifying authorities such as NSDL and UIDAI. The Company shall
              have
              no
              liability whatsoever
              arising from or relating to the User’s use of optional third-party tools and services.
              The
              User
              is requested to
              review the third-party’s policies and practices carefully and make sure that the User
              understands them. Complaints,
              concerns, or questions regarding third-party products should be directed to the
              third-party.
            </li>

            <li>
              Without prejudice to the above, where any documents are signed, verified or stored
              with
              the
              Company or under the
              Services, the Company expressly disclaims any liability in connection with such
              documents
              and
              the Company is not
              responsible for the verification of the terms of the documents, enforceability of such
              documents
              or any disputes in
              connection with such documents.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Phishing</span>
          <ol>
            <li>
              The Company has ensured that the Website is HTTPS enabled to better protect the User’s
              security
              against dummy
              websites. Please verify that the Webpage is HTTPS enabled before providing any
              information
              on
              it. The Company will
              not be liable for any consequences of the User providing details on any third-party
              website,
              including dummy
              websites.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Services and Pricing</span>
          <ol>
            <li>
              The Services enable Users to inter alia execute documents between Users on the Website
              and
              receive other ancillary
              and incidental services as provided by the Company from time to time. In connection
              with the
              Services, the Company
              reserves the right to add or remove any services or specify the pricing for the
              Services at
              the
              discretion of the
              Company with whatever notice the Company deems fit. Please note that the Services must
              be
              availed and used in
              accordance with applicable laws.
            </li>
            <li>
              In addition to the fees payable for a Transaction, the User will also have to prepay
              all
              other
              fees, charges and
              costs that are required to be paid, as specified by the Company, in connection with
              any
              other
              Services availed by
              the User.
            </li>
            <li>
              For the prepayment of the charges of the Company for any Services, the User will
              have to use
              an
              appropriate payment
              instrument such as bank account, credit or debit card or semi closed prepaid wallet
              for the
              payment to the Company,
              which may be made available by the Company at its discretion. Please note that a
              payment to
              the
              Company is executed
              by Company’s payments partner and the Company is not liable for any loss or damage to
              the
              User
              from the use of such
              service.
            </li>
            <li>
              {' '}
              Notwithstanding anything contained in this Terms of Use, the User acknowledges that
              the
              User’s
              ability to avail the
              Services or execute Transactions may be frozen without any intimation to enable the
              Company
              to
              comply with any of
              Company’s regulatory (including self-regulatory) and legal obligations.
            </li>
            <li>
              The Company facilitates the execution of documents between persons and the Use of
              the
              Services
              shall not be
              construed to make the Company a party to any document and the Company makes no
              representation
              or
              warranty regarding
              the authority and the capacity of the parties for the execution, the content or the
              document
              or
              the enforceability
              of the document. Please note that certain documents may not be electronically
              executed, as
              specified under
              applicable laws.
            </li>
            <li>
              The Company has no control of or access to the contents of documents executed by
              Users and
              the
              Company assumes no
              responsibility in respect of such documents.
            </li>
            <li>
              The Company is not responsible for determining how long any contracts, documents,
              and other
              records are required to
              be retained or stored under any applicable laws, regulations, or legal or
              administrative
              processes and the Company
              does not assume any responsibility for the production of documents to any legal or
              regulatory
              agency.
            </li>
            <li>
              At the request of the User, the Company facilitates the procurement of stamp paper
              and
              payment
              of stamp duty on
              documents executed using the Company’s Services. In such instance, the Company shall
              act as
              a
              pure agent under the
              Central Goods and Services Tax Act, 2017. The Company may execute such processes with
              third
              party service providers.
              The User shall be liable to pay the charges for such services, as specified by the
              Company.
            </li>
            <li>
              The User shall be solely responsible for ascertaining the appropriate stamp duty
              payable and
              the
              Company shall in no
              way be responsible or be under any obligation to ascertain the appropriate stamp duty
              payable.
              The Company is not
              liable if the documents uploaded on the website are not duly stamped or for
              ascertaining
              other
              legal processes such
              as registration, notarisation.
            </li>
            <li>
              The Company does not warrant that the Services will comply with any specific
              industry
              standard
              or regulatory
              requirement applicable to a User.
            </li>
            <li>
              The Company will provide billing and usage information in a format of the Company’s
              choosing,
              which may change from
              time to time. The Company reserves the right to correct any errors or mistakes that it
              identifies even if it has
              already issued an invoice or received payment. The User agrees to notify us about any
              billing
              problems or
              discrepancies within 14 (fourteen) days of the issue of the invoice. If User does not
              bring
              such
              problems/discrepancies to the Company’s notice within 14 (fourteen) days, the User
              shall
              have
              waived its right to
              dispute such problems or discrepancies.
            </li>
            <li>
              The Company does not monitor or verify any personally identifiable information that
              may be
              provided by the Users as
              a part of the services or in any document executed using the Services. The User
              represents
              and
              warrants the User’s
              authority to provide and use such personally identifiable information and agrees that
              the
              Company shall not be
              liable for the same in any manner whatsoever for the same and the User shall defend,
              indemnify
              and hold harmless the
              Company for any claims in this regard. The User further accepts that the Company may
              store
              personal information of
              Users and details of use of the Services as required under regulatory requirements.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Refunds</span>
          <ol>
            <li>
              No refunds shall be provided for Services purchased by a User. Further, any eSign
              transactions
              purchased by the User
              shall be valid for 365 (three hundred and sixty five days) from the date of purchase.

            </li>
            <li>
              Any amounts already paid to the Company for any Services may not be set-off for any
              alternate
              Services or products.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Restrictions on Use</span>
          <p>The User shall not:</p>
          <ol>
            <li>
              Use the services for spamming and other illegal purposes;
            </li>
            <li>
              Impersonate any person or entity, falsely claim or otherwise misrepresent an
              affiliation
              with
              any person or entity,
              or access the accounts of others without their permission, forge another persons’
              digital
              signature, misrepresent
              the source, identity, or access the accounts of others without permission, ,
              misrepresent
              the
              content of information
              transmitted via the services, perform any other similar fraudulent activity, use the
              Services
              for any illegal
              activity or otherwise purchase product or service which we reasonably believe to be
              potentially
              fraudulent;
            </li>
            <li>
              Defames the Company, its employees, officers, directors, agents, partners and service
              providers,
              including without
              limitation, by posting any defamatory content on any social media;
            </li>
            <li>
              Infringe our or any third party’s intellectual property rights, rights of publicity or
              privacy;
            </li>
            <li>
              Use the service if the User is below the age of 18 (eighteen) (or otherwise as
              permitted, as
              specified above) and in
              accordance with applicable law;
            </li>
            <li>
              Post or transmit any message, data, image or program which is grossly harmful,
              harassing,
              blasphemous, defamatory,
              obscene, pornographic, pedophilic, invasive of another’s privacy, hateful, or
              racially,
              ethnically objectionable,
              disparaging, relating or encouraging money laundering or gambling, or otherwise
              unlawful in
              any
              manner whatever;
            </li>
            <li>
              Refuse to cooperate in any investigation or provide confirmation of identity or any
              other
              information as asked by
              the Company;
            </li>
            <li>
              Remove, circumvent, disable, damage or otherwise interfere with security-related
              features of
              the
              service and the
              Website or features that enforce limitations in the use of the services;
            </li>
            <li>
              Use the service in any manner that could damage, disable, overburden, or impair it,
              including
              without limitation,
              using the services in an automated manner;
            </li>
            <li>
              Use any robot, spider, other automatic device, or manual process to monitor or copy
              the
              Website
              without prior
              written permission;
            </li>
            <li>
              Reverse engineer, decompile or otherwise extract the source code related to the
              Website and
              the
              Services;
            </li>
            <li>
              Interfere or disrupt the Website or the Services or networks connected to this Website
              or
              used
              to provide the
              Services;
            </li>
            <li>
              Forge headers or manipulate identifiers or other data in order to disguise the origin
              of any
              content transmitted
              through our Website or to manipulate the User’s presence on the Website; and
            </li>
            <li>
              Use Website to collect or obtain personal information, including but not limited to
              financial
              information, about
              other users of the Website.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Intellectual Property rights</span>
          <ol>
            <li>
              The Services offered and the Website are owned and operated by the Company. The visual
              interfaces, graphics, design,
              compilation, information, computer code (including source code and object code),
              products,
              software, services, and
              all other elements of the services and the Website provided by the Company
              (“
              <b>Materials</b>
              ”) are
              protected by Indian
              copyright, trade secret, patent and trademark laws, international conventions and all
              other
              intellectual property
              and proprietary rights and applicable laws. As between the User and the Company, all
              Materials
              and other trademarks,
              service marks, and trade names contained on the Website are the property of the
              Company
              and/or
              third party licensors
              or suppliers.
            </li>
            <li>
              The User agrees not to remove, obscure, or alter the Company’s or any third party’s
              copyright,
              patent, trademark, or
              other intellectual or proprietary right notices affixed to or contained within or
              accessed
              in
              conjunction with or
              through the Services. The User shall not sell, license, distribute, copy, modify,
              publicly
              perform or display,
              transmit, publish, edit, adapt, create derivative works from, or otherwise make
              unauthorized
              use
              of the Materials.
              The Company reserves all rights not expressly granted in these Terms of Use.
            </li>
            <li>
              Where the User is using the Services for the benefit of the employer of the User, by
              confirming
              these Terms of Use,
              the User confirms that the employer of the User shall also be bound by the Terms of
              Use,
              without
              any multiplication
              of rights, and the employer of the User may be represented by the Company as a user of
              the
              Services.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Suspension</span>
          <p>
            The Company reserves the right to suspend/discontinue its products/services to the User
            and/or
            to sever its
            relationship with the User, at any time, for any cause, including, but not limited, to
            the
            following:
          </p>
          <ol>
            <li>
              For any suspected violation of the rules, regulations, orders, directions,
              notifications,
              laws,
              statutes, from time
              to time or for any violation of the terms and conditions mentioned in these Terms of
              Use.
            </li>
            <li>
              For any suspected discrepancy in the particular(s), documentation or information
              provided by
              the
              User;
            </li>
            <li>
              To combat potential fraud, sabotage, willful destruction, threat to national
              security, for
              any
              other force majeure
              reasons etc.;
            </li>
            <li>
              If the same is due to technical failure, modification, upgradation, variation,
              relocation,
              repair, and/or
              maintenance due to any emergency or for any technical reasons;
            </li>
            <li>
              If the same is due to any transmission deficiencies caused by topographical and
              geographical
              constraints/limitations;
            </li>
            <li>
              If the User does not have the control over the User’s login details and password or
              the
              User’s
              account is
              compromised in any other manner;
            </li>
            <li>
              If the Company believes, in its reasonable opinion, that cessation/ suspension is
              necessary.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Disclaimer of Warranties & Liability</span>
          <ol>
            <li>
              The Website, services, content, user content and any third party content are provided
              by the
              Company on an “As is”
              basis without warranty of any kind, express, implied, statutory or otherwise,
              including the
              implied warranties of
              title, non-infringement, Merchantability or fitness for a particular purpose, without
              limiting
              the foregoing, the
              Company makes no warranty that:
              <ol className="tcp-section-alpha-ol">
                <li>
                  The Website or the services will meet the User’s requirements or the User’s use of
                  the
                  Website
                  or the services will
                  be uninterrupted, timely, secure or error-free.
                </li>
                <li>
                  The results that may be obtained from the use of the Website or services will be
                  effective
                  accurate or reliable.
                </li>
                <li>
                  The quality of the Website or services will meet the User’s expectations; or
                </li>
                <li>
                  Any errors or defects in the Website through the Website/Content or from use of
                  the services
                  shall create any
                  warranty not expressly stated in these Terms of Use.
                </li>
              </ol>
            </li>

            <li>
              The Company will have no liability related to user content and/or third party content
              arising
              under Intellectual
              Property Rights, libel, privacy, publicity, obscenity or other laws, the Company
              disclaims
              all
              liability with
              respect to the misuse, loss, modification or unavailability of any user content and/or
              third
              party content.
            </li>

            <li>
              The User expressly understands and agrees that, to the maximum extent permitted by
              applicable
              law the Company will
              not be liable for any loss that a User may incur as a consequence of unauthorized use
              of
              the
              User’s account or
              account information in connection with the Website or any services, either with or
              without
              the
              User’s knowledge. The
              Company has endeavored to ensure that all the information on the Website is correct,
              but
              the
              Company neither
              warrants nor makes any representations regarding the quality, accuracy or completeness
              of
              any
              data, information,
              software, products, functionalities, services and related graphics obtained through
              the
              Website,
              or otherwise
              arising out of the use of this Website, whether based on contract, tort, negligence,
              strict
              liability or otherwise,
              further, the Company shall not be held responsible for non-availability of the Website
              during
              periodic maintenance
              operations or any unplanned suspension of access to the Website that may occur due to
              technical
              reasons or any other
              reasons beyond the Company’s control. The User understands and agrees that any
              material or
              data
              downloaded or
              otherwise obtained through the Website is done entirely at their own discretion and
              risk
              and
              they will be solely
              responsible for any damage to their computer systems or loss of data that results from
              the
              download of such material
              or data. The Company accepts no liability for any errors or omissions, with respect to
              any
              information provided to
              the User whether on behalf of itself or third parties.
            </li>
          </ol>
        </li>

        <li>
          <span
            className="tcp-section-item-header"
          >
            Indemnification and Limitation of Liability
          </span>
          <ol>
            <li>
              The User agrees to indemnify, defend and hold harmless the Company, its
              subsidiaries,
              affiliates, vendors, agents
              and their respective directors, shareholders, officers, employees, contractors and
              agents
              (herein after individually
              and collectively referred to as (“
              <b>Indemnified Parties</b>
              ”) from and against any and all
              losses,
              liabilities, claims,
              suits, proceedings, penalties, interests, damages, demands, costs and expenses
              (including
              legal
              and other statutory
              fees and disbursements in connection therewith and interest chargeable thereon)
              asserted
              against
              or incurred by the
              indemnified parties that arise out of, result from, or in connection with (i) a User’s
              breach
              of
              the Terms of Use;
              or (ii) any claims made by any third party against the Indemnified Parties due to, or
              arising
              out of, or in
              connection with a User’s use of the Website or the Services; or (iii) any claim that
              any
              content, information or
              materials provided by a User caused damage to a third party; or (iv) a User’s
              violation of
              applicable laws or any
              rights of another, including any intellectual property rights.
            </li>
            <li>
              The Company may notify the User of any claims which the User shall be liable to
              indemnify
              against for the
              Indemnified Parties. The User will then be required to consult with the Company
              regarding
              the
              course of action to be
              undertaken in defending such a claim. Further, the User shall not compromise or settle
              any
              claim
              or admit any
              liability or wrongdoing on the part of the Company without the express prior written
              consent
              of
              the Company which
              can be withheld or denied or conditioned by the Company in its sole discretion.
            </li>
            <li>
              Notwithstanding anything to contrary in the agreement(s), The Company’s entire and
              aggregate
              liability under and in
              relation to these Terms of Use or otherwise shall not exceed the greater of INR 100
              (Indian
              Rupees one hundred) or
              the amount of fees (less any expenses, convenience fee and delivery fee), if any, paid
              by a
              User
              or on behalf of a
              User to the Company in connection with the execution of a document. The total
              aggregate
              liability of the Company
              shall not exceed INR 10,000 (Indian Rupees ten thousand) to any User.
            </li>
            <li>
              Notwithstanding anything to the contrary, the Company, its successors, agents,
              assigns, and
              each
              of their directors,
              officers, employees, associates, agents, and representatives shall in no event be
              liable to
              the
              User or any other
              person for any indirect, incidental, special, consequential, punitive or economic
              loss,
              expense
              or damage arising
              from or in connection with any access, use or the inability to access or use the
              Company’s
              products/services and
              data/content or reliance on those, including without limitation, the Services and the
              Website,
              howsoever caused and
              regardless of the form of action (including tort or strict liability), or from any
              downtime
              costs, loss of revenue
              or business opportunities, loss of profit, loss of anticipated savings or business,
              loss of
              data, loss of goodwill
              or loss of value of any equipment including software.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">Governing Law and Jurisdiction</span>
          <ol>
            <li>
              These Terms of Use and all transactions entered into on or through the Website and
              the
              relationship between a User
              and the Company, in connection with the Services or otherwise, shall be governed in
              accordance
              with the laws of
              India without reference to conflict of laws principles.
            </li>
            <li>
              The User agree that all claims, differences and disputes arising under or in
              connection with
              or
              in relation hereto
              the Website, these Terms of Use, the agreement(s) or any transactions entered into on
              or
              through
              the Website or the
              relationship between a User (or any person claiming under a User) and the Company
              shall be
              resolved by final and
              binding arbitration by a sole arbitrator under the Arbitration and Conciliation Act,
              1996.
              The
              sole arbitrator shall
              be appointed by the mutual consent of the User and the Company. The language of the
              arbitration
              shall be English and
              the seat of arbitration shall be Gurgaon, Haryana.
            </li>
          </ol>
        </li>

        <li>
          <span className="tcp-section-item-header">General Provisions</span>
          <ol>
            <li>
              <b>Notice: </b>
              All notices with respect to these Terms of Use from the Company will be served
              to
              the
              User by email or by
              general notification on the Website. Any notice provided to the Company pursuant to
              these
              Terms
              of Use should be
              sent to Grievance Officer.
            </li>
            <li>
              <b>Assignment: </b>
              The User cannot assign or otherwise transfer the Terms of Use or the
              Services to
              be
              received by a User,
              or any rights granted hereunder or any obligations, to any third party and any such
              assignment
              or transfer or
              purported assignment or transfer shall be void ab initio. The Company’s rights and/or
              obligations under the Terms of
              Use or in respect of the Services are freely assignable or otherwise transferable by
              the
              Company
              to any third
              parties without the requirement of seeking the User’s prior consent. The Company may
              inform
              the
              Users of such
              assignment or transfer in accordance with the notice requirements under the agreement.
              The
              Company shall have right
              to transfer the User’s account and account information to a third party or its
              affiliates
              who
              acquires the Company
              or the business of the Company.
            </li>
            <li>
              <b>Severability: </b>
              If, for any reason, a Court of competent jurisdiction finds any
              provision of
              these
              Terms of Use, or
              portion thereof, to be unenforceable, that provision shall be enforced to the maximum
              extent
              permissible so as to
              give effect to the intent of the parties as reflected by that provision, and the
              remainder
              of
              the Terms of Use shall
              continue in full force and effect. The Company may amend in a reasonable manner such
              provision
              to make it
              enforceable and such amendment will be given effect in accordance with the amendment
              terms
              of
              these Terms of Use.
            </li>
            <li>
              <b>Waiver: </b>
              Any failure or delay by the Company to enforce or exercise any provision of
              the
              Terms
              of
              Use, or any related
              right, shall not constitute a waiver by the Company of that provision or right. The
              exercise
              of
              one or more of the
              Company’s rights hereunder shall not be a waiver of, or preclude the exercise of, any
              rights
              or
              remedies available
              to such party under these Terms of Use or in law or at equity. Any waiver by the
              Company
              shall
              only be made in
              writing and executed by a duly authorized officer of such party.
            </li>
            <li>
              <b>Principal to Principal Relationship: </b>
              The User and the Company are independent
              contractors,
              and
              nothing in these
              Terms of Use will be construed to create a partnership, joint venture, association of
              persons,
              agency (disclosed or
              undisclosed), franchise, sales representative, or employment relationship between a
              User and
              the
              Company. As an
              abundant caution, it is clarified that the Company shall not have any right to
              conclude any
              contracts agreements for
              and / or on the User’s behalf and both the User and the Company have entered this
              agreement
              on
              principal to
              principal basis.
            </li>
            <li>
              <b>Force Majeure: </b>
              If performance of any service or obligation under these Terms of Use or
              other
              agreement by the
              Company is, or other third parties in fulfillment of any transaction (for e.g:
              logistics
              service
              provider, payment
              gateways etc.) are, prevented, restricted, delayed or interfered with by reason of
              labor
              disputes, strikes, acts of
              God, floods, lightning, severe weather, shortages of materials, rationing, utility or
              communication failures,
              earthquakes, war, revolution, acts of terrorism, civil commotion, acts of public
              enemies,
              blockade, embargo or any
              law, order, proclamation, regulation, ordinance, demand or requirement having legal
              effect
              of
              any government or any
              judicial authority or representative of any such government, or any other act
              whatsoever,
              whether similar or
              dissimilar to those referred to in this clause, which are beyond the reasonable
              control of
              the
              Company or its third
              parties performing such services (each, a
              {' '}
              <b>“Force Majeure Event”</b>
              ), then the Company
              shall be
              excused from such
              performance to the extent of and during the period of such Force Majeure Event. The
              Company
              shall exercise all
              reasonable commercial efforts to continue to perform its obligations hereunder after
              the
              Force
              Majeure Event. In
              case of a Force Majeure Event, the User’s shall not be entitled to any refunds for any
              amounts
              paid, unless
              specified otherwise by the Company.
            </li>
            <li>
              <b>Grievance Officer: </b>
              In compliance with Information Technology Act, 2000 and the rules
              made
              thereunder, the Grievance
              Officer of the Company for the purpose of these Terms of Use is set out below. The
              Company
              may
              change the aforesaid
              details from time to time.
            </li>
          </ol>
        </li>
      </ol>

      <b>Name: </b>
      Mr. Prakhar Agarwal
      <br />
      <b>Email Address: </b>
      support@leegality.com
      <br />
      <b>Address: </b>
      Plot no.444, Phase III, Udyog Vihar, Sector 18, Gurugram, Haryana 122022
    </article>
  </section>
);

TermsConditions.propTypes = {};

TermsConditions.defaultProps = {};

export default TermsConditions;
